import { Flex } from '@fastnorth/kraken/components/layout';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { NavLink } from '@fastnorth/kraken/components/navigation';

type EventLinkProps = {
  eventUrl: string;
};

const EventLink = ({ eventUrl }: EventLinkProps): React.JSX.Element => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.layout.header' });

  return (
    <Flex className={'w-full'}>
      <NavLink id={'event-link'} accent={'secondary'} variant={'menuPill'} width={'full'}>
        <Link to={eventUrl} data-dd-action-name={'link-event_details-hamburger_menu'}>
          {t('event_details')}
          <ArrowRight role={'presentation'} size={16} strokeWidth={2} className={'ml-4'} />
        </Link>
      </NavLink>
    </Flex>
  );
};

export default EventLink;
